import { render, staticRenderFns } from "./QrCodeScanner.vue?vue&type=template&id=2c13acfd"
import script from "./QrCodeScanner.vue?vue&type=script&lang=js"
export * from "./QrCodeScanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports